const STORAGE_KEYS = {
    STAFF_LOGIN: 'stafflogin',
    CLIENT_LOGIN: 'clientlogin',
    INTERNAL_LOGIN: 'internallogin',
    TS_AREA: 'tsarea',
    SHIPPING_OPEN_PRINTER: 'shippingopenprinter',
    SHIPPING_CLOSE_PRINTER: 'shippingcloseprinter',
    GUGLE_INFO: 'gugleinfo',
    MATERIAL_TRACE_MACHINE: 'materialtracemachine'
};

const UPS_SERVICES = [
    { code : '01', desc: ' Next Day Air', active : true},
    { code : '02', desc: ' 2nd Day Air', active : true},
    { code : '03', desc: ' Ground', active : true},
    { code : '07', desc: ' Express', active : true},
    { code : '08', desc: ' Expedited', active : true},
    { code : '11', desc: ' UPS Standard', active : true},
    { code : '12', desc: ' 3 Day Select', active : true},
    { code : '13', desc: ' Next Day Air Saver', active : true},
    { code : '14', desc: ' UPS Next Day Air® Early', active : true},
    { code : '17', desc: ' UPS Worldwide Economy DDU', active : true},
    { code : '54', desc: ' Express Plus', active : false},
    { code : '59', desc: ' 2nd Day Air A.M.', active : false},
    { code : '65', desc: ' UPS Saver', active : false},
    { code : 'M2 ', desc: ' First Class Mail', active : false},
    { code : 'M3 ', desc: ' Priority Mail', active : false},
    { code : 'M4 ', desc: ' Expedited MaiI Innovations', active : false},
    { code : 'M5 ', desc: ' Priority Mail Innovations', active : false},
    { code : 'M6 ', desc: ' Economy Mail Innovations', active : false},
    { code : 'M7 ', desc: ' MaiI Innovations (MI) Returns', active : false},
    { code : '70', desc: ' UPS Access Point™ Economy', active : false},
    { code : '71', desc: ' UPS Worldwide Express Freight Midday', active : false},
    { code : '72', desc: ' UPS Worldwide Economy DDP', active : false},
    { code : '74', desc: ' UPS Express®12:00', active : false},
    { code : '75', desc: ' UPS Heavy Goods', active : false},
    { code : '82', desc: ' UPS Today Standard', active : false},
    { code : '83', desc: ' UPS Today Dedicated Courier', active : false},
    { code : '84', desc: ' UPS Today Intercity', active : false},
    { code : '85', desc: ' UPS Today Express', active : false},
    { code : '86', desc: ' UPS Today Express Saver', active : false},
    { code : '93', desc: ' Ground Saver', active : false},
    { code : '96', desc: ' UPS Worldwide Express Freight.', active : false},
    { code : 'C6 ', desc: ' Roadie XD AM (Morning delivery)', active : false},
    { code : 'C7 ', desc: ' Roadie XD PM (Afternoon delivery)', active : false},
    { code : 'C8 ', desc: ' Roadie XD (Anytime delivery)', active : false},
    { code : 'T0 ', desc: ' Master', active : false},
    { code : 'T1 ', desc: ' LTL', active : false}
];

module.exports = {
    Colors: {
        Primary:{
            Main: '#1976d2',
            MainAlpha : 'rgba(25, 118, 210, 0.6)'
        },
        Secondary:{
            Main: '#dc004e',
            MainAlpha : 'rgba(220, 0, 78, 0.6)'
        },
        Font: {
            White: '#ffffff'
        }
    },
    API: 'http://192.168.100.209:3001/api/',
    LANDING_ROUTES : [
        {
            name: 'Production Management',
            path: '/productionmanagement'
        },
        {
            name: 'Order Management',
            path: '/ordermanagement'
        },
        {
            name: 'Tracking Station',
            path: '/trackstation'
        },
        
        {
            name: 'Bagging Stations',
            path: '/baggingstation/main'
        },
        {
            name: 'Shipping Stations',
            path: '/shippingstation/main'
        },
        {
            name: 'Shipping Labeler Station',
            path: '/shippinglabelerstation'
        },
        {
            name: 'Order Tracker',
            path: '/ordertracker'
        },
        {
            name: 'QA Polish',
            path: '/qapolish'
        },
        {
            name: 'QA Shipping',
            path: '/qashiping'
        },
        {
            name: 'Platform Settings',
            path: '/platformsettings'
        },
        {
            name: 'FGS MANAGEMENT',
            description: 'Manage client FGS configurations',
            path: '/fgsmanagement'
        },
        {
            name: 'MATERIAL TRACEABILITY',
            description: 'Track orders by material roll and machine',
            path: '/materialtraceability'
        },
        {
            name: 'TRACKING ACCESS',
            description: 'Manage Tracking Station credentials',
            path: '/trackingaccess'
        },
        {
            name: 'SHIPPING LABEL MANAGEMENT',
            description: 'Manage and archive shipping labels',
            path: '/shippinglabelmanagement'
        },
    {name: 'ORDER LOOKUP', description: 'Current status and order history', path: '/trackinglookup'},
        {
            name: 'BOM AUTOMATIC PRINTING',
            description: 'Print BOM labels automatically by FGS',
            path: '/bomprinting'
        },
        {
            name: 'PM LABELING',
            description: 'Create and track preventive-maintenance labels',
            path: '/pmlabeling'
        }
    ],
    STORAGE_KEYS : STORAGE_KEYS,
    TS_LOGOUT_KEYS : [
        STORAGE_KEYS.STAFF_LOGIN,
        STORAGE_KEYS.TS_AREA
    ],
    OM_LOGOUT_KEYS : [
        STORAGE_KEYS.CLIENT_LOGIN
    ],
    PM_LOGOUT_KEYS : [
        STORAGE_KEYS.INTERNAL_LOGIN
    ],
    SHIPPING_KEYS : [
        STORAGE_KEYS.SHIPPING_OPEN_PRINTER,
        STORAGE_KEYS.SHIPPING_CLOSE_PRINTER,
    ],
    PRODUCTION_CSV_REPORT : [
        {
            TITLE: 'G-Code',
            INIT: { ID:6 , DESC:'Init'},
            ERROR: { ID:7 , DESC:'Error'},
            PASS: { ID:8 , DESC:'Complete'}
        },
        {
            TITLE: '3D',
            INIT: { ID:9 , DESC:'Init'},
            ERROR: { ID:10 , DESC:'Error'},
            PASS: { ID:11 , DESC:'Complete'}
        },
        {
            TITLE: 'Machining',
            INIT: { ID:12 , DESC:'Init'},
            ERROR: { ID:13 , DESC:'Error'},
            PASS: { ID:14 , DESC:'Complete'}
        },
        {
            TITLE: 'Polishing',
            INIT: { ID:15 , DESC:'Init'},
            ERROR: { ID:16 , DESC:'Error'},
            PASS: { ID:17 , DESC:'Complete'}
        },
        {
            TITLE: 'Packaging',
            INIT: { ID:18 , DESC:'Init'},
            ERROR: { ID:19 , DESC:'Error'},
            PASS: { ID:20 , DESC:'Complete'}
        },
        {
            TITLE: 'Shiping',
            INIT: { ID:21, DESC:'Init'},
            ERROR: { ID:22 , DESC:'Error'},
            PASS: { ID:23 , DESC:'Complete'}
        },
    ],
    KLINE_CLIENTS : [
        'Dandy',
        'Impress',
        'PhaseOrtho',
        'SmileSet',
        'SmileShapers'
    ],
    UPS_SERVICES : UPS_SERVICES
}
